export type PeriodBadgeVariant = "status" | "active" | "success";

const periodBadgeClassNames: Record<PeriodBadgeVariant, string> = {
  status: "bg-light text-primary border",
  active: "bg-light text-success border border-success",
  success: "bg-light text-success border border-success",
};

export const getPeriodStatusBadgeVariant = (
  statusId: string | null | undefined,
  statusLabel: string | null | undefined,
): PeriodBadgeVariant =>
  statusId === "ModtagetUdenFejl" || statusLabel === "Modtaget uden fejl"
    ? "success"
    : "status";

interface PeriodBadgeProps {
  label: string;
  variant: PeriodBadgeVariant;
}

export const PeriodBadge = ({ label, variant }: PeriodBadgeProps) => (
  <span
    className={`badge rounded-pill border-primary px-3 py-2 fw-semibold ${periodBadgeClassNames[variant]}`}
  >
    {label}
  </span>
);
